import React from "react";
import { Loader2 } from "lucide-react";

// 인증·약관 확인 중에만 쓰는 화면. 헤더·사이드바 없이 스피너만 둔다 —
// 어느 라우트로 들어왔는지 모르는 시점이라 특정 화면의 껍데기를 먼저 보여주면 틀린 디자인이 스친다
export const LoadingSpinner: React.FC = () => {
  return (
    <div
      role="status"
      aria-label="로딩 중"
      className="min-h-screen h-screen bg-white flex items-center justify-center"
    >
      <Loader2 aria-hidden className="h-8 w-8 animate-spin text-neutral-400" />
    </div>
  );
};
